export default __webpack_public_path__ + "static/media/prod-img-6.7274a39c.webp";